import React, { forwardRef } from 'react';
import { bool, array } from 'prop-types';
import ProductReviewsListItem from './ProductReviewsListItem';

/**
 * @type {ReturnType<typeof forwardRef<typeof HTMLDivElement, import('prop-types').InferProps<typeof ProductReviewListContainerProps>>>}
 */
const ProductReviewListContainer = forwardRef(({ hasNoReviews, reviews }, ref) => {
    return hasNoReviews ? (
        <p
            className={'product-reviews-list--no-content'}>
            There are no reviews for this product yet.
            Be the first to write a review.
        </p>
    ) : (
        <div
            className={'product-reviews-list--list-container'}
            ref={ref}>
            {reviews.map(
                (review) => <ProductReviewsListItem
                    key={review.title}
                    review={review}
                />
            )}
        </div>
    );
});

const ProductReviewListContainerProps = {
    hasNoReviews: bool,
    reviews: array,
};
ProductReviewListContainer.displayName = 'ProductReviewListContainer';
ProductReviewListContainer.propTypes = ProductReviewListContainerProps;
export default ProductReviewListContainer;